import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import {
  gradientColors,
  partialCtaDefaultLinearGradientBackground,
  partialCtaHoverLinearGradientBackground,
} from "@/components/AIComponents/AiComponents.style";

const { colors } = constants;
const neutral600 = colors.ui.neutral[600];

export const buttonRootCss: CSSObject = {
  ...partialCtaDefaultLinearGradientBackground,
  "&:hover, &:focus-visible": {
    ...partialCtaHoverLinearGradientBackground,
  },
};

export const modalRootCss: CSSObject = {
  zIndex: 99,
};

export const modalContentWrapperCss: CSSObject = {
  maxWidth: "1244px !important",
  maxHeight: "800px !important",
  border: "2px solid transparent",
  borderImage: `linear-gradient(to bottom right, ${gradientColors.position0}, ${gradientColors.position25}, ${gradientColors.position50}, ${gradientColors.position100}) 1`,
};

export const scrollableBodyCss: CSSObject = {
  padding: "0 !important",
};

export const modalFooterCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px",
  paddingBottom: "32px",
  minHeight: "unset",
};

export const warningTextCss: CSSObject = {
  color: neutral600,
  fontSize: "14px",
  lineHeight: "20px",
};

export const loadingWrapper: CSSObject = {
  height: "70vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const loadingSpinnerWrapper: CSSObject = {
  height: "96px",
  width: "96px",
};
